import React from 'react';
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import {
  Container, Button, Form, Modal 
} from "react-bootstrap";
import FocusTrap from "focus-trap-react";
import http from "../../api/http-request";
import CloseIcon from "../../assets/images/close-icon.svg";

const RemoveDevicePopup = (props) =>{
    const {onClose,identifier,userData:{userName},removeDevicePrompt} = props;
    const {t} = useTranslation();
    const yesHandler = (e) =>{
    e.preventDefault();
    const dataStoreToken = localStorage.getItem("authToken");
    const bearer = 'Bearer ';
    http({
      url:`users/${encodeURIComponent(userName)}/devices/profile/${identifier}`,
      method:"DELETE"
    },
    {
      Authorization:`${bearer}${dataStoreToken}`,
      "Accept-API-Version": "resource=1.0"

    }).then((res)=>{
        const response = res;
        console.log(response);
        if(res.status ===200 && res.data.identifier){
            removeDevicePrompt("success",userName);
            onClose();
        }else if(res.status === 401 && res.code==="401"){
            removeDevicePrompt("error");
            onClose();
        }
    })
    }
    const noHandler = (e) =>{
        e.preventDefault();
        onClose();
    } 
    return(
        <Modal
            show
            animation={false}
            onEscapeKeyDown={() => onClose()}
            aria-labelledby="mobile-modal"
        >
            <FocusTrap>
            <div className="popup change-mobile-number">
                <Container fluid>
                <div className="popup__wrapper">
                    <Form>
                    <div className="popup__wrapper-body">
                        <div className="popup__wrapper-body-header">
                        <h6 id="mobile-modal">
                            {t("pages.profile.removeDevice")}
                        </h6>
                        <Button
                            className="popup__wrapper-body-header-close"
                            onClick={() => {
                            onClose();
                            }}
                            variant="light"
                            aria-label="Close"
                        >
                            <img src={CloseIcon} alt="" />
                        </Button>
                        </div>
                        <>
                            <p className="popup__wrapper-body-desc">
                            {t("pages.profile.removeDeviceDesc")}
                            </p>
                            {/* <div className="popup__wrapper-body-email">
                            <Form.Group controlId="name">
                                <Form.Label>
                                {t("pages.profile.newName")}
                                </Form.Label>
                                <Form.Control
                                type="text"
                                onChange={renameChangeHandler}
                                value={rename}
                                aria-required
                                className={nameError ? "error-input" : undefined}
                                aria-invalid={!!nameError}
                                aria-describedby="name-error"
                                />
                                
                            </Form.Group>
                            </div> */}
                            {/* <p className="error-text" id="name-error">
                            {nameError && t("pages.profile.nameError")}
                            </p> */}
                        </>
                    </div>
                    <div className="popup__wrapper-footer">
                        <Button
                            className="wrapper__container-card-body-submit"
                            size="lg"
                            variant="primary"
                            block
                            type="submit"
                            onClick={(e) => yesHandler(e)}
                        >
                            {t("pages.login.Yes")}
                        </Button>
                        <Button
                            className="wrapper__container-card-body-submit"
                            size="lg"
                            variant="primary"
                            block
                            type="submit"
                            onClick={(e) => noHandler(e)}
                        >
                            {t("pages.login.No")}
                        </Button>
                    </div>
                    </Form>
                </div>
                </Container>
            </div>
            </FocusTrap>
        </Modal>
    );
}

export default RemoveDevicePopup;